// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".color-picker-pickerContent--1JqRZQGQTjeBaCo45Zr6u6{width:480px}.color-picker-divider--27L9U8gpCq2noRQVAPMkEr{height:auto}.color-picker-colorPicker--3em4W36akgQSfezJ1g1HE2{width:auto}", "",{"version":3,"sources":["webpack://src/components/common/ColorPicker/colorPicker.module.scss"],"names":[],"mappings":"AAAA,oDACC,WAAA,CAGD,8CACC,WAAA,CAGD,kDACC,UAAA","sourcesContent":[".pickerContent {\r\n\twidth: 480px;\r\n}\r\n\r\n.divider {\r\n\theight: auto;\r\n}\r\n\r\n.colorPicker {\r\n\twidth: auto;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pickerContent": "color-picker-pickerContent--1JqRZQGQTjeBaCo45Zr6u6",
	"divider": "color-picker-divider--27L9U8gpCq2noRQVAPMkEr",
	"colorPicker": "color-picker-colorPicker--3em4W36akgQSfezJ1g1HE2"
};
export default ___CSS_LOADER_EXPORT___;
